export default {
  meta: {
    title: '自定义指标推荐',
    url: '/recommend/map', // 埋点用，记录所属模块
    // eventId: '73e56bba-e348-40be-bc54-25b4610e6682'
  },
};
